import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { burnDownReportEntrypoint } from '@atlassian/jira-spa-apps-next-gen-reports-burndown/entrypoint.tsx';

export const BurnDownReportPageEntrypoint = createPageEntryPoint({
	main: burnDownReportEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
